import { useRef, useEffect, useCallback } from "react";

/**
 * Retorna una función segura para comprobar si el componente
 * sigue montado antes de actualizar el estado tras llamadas asíncronas.
 */
export function useIsMounted() {
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
}